export enum ChannelSourceType {
  POAP = "poap_",
  SAFE = "safe_",
  NFT = "erc721_",
  DIRECT = "direct",
}
